var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrFreeSpins(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.303 8.944h2.806l-2.204 5.227h1.44l2.2-5.454v-.91h-4.242v1.137zM11.92 14.171h-1.438l2.204-5.228H9.879V7.808h4.243v.908l-2.201 5.455zM4.497 14.171h-1.44l2.204-5.228H2.455V7.808h4.242v.908l-2.2 5.455z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.076.383c.877 0 1.59.714 1.59 1.591v18.03c0 .878-.713 1.591-1.59 1.591H1.924c-.877 0-1.59-.713-1.59-1.59V1.974c0-.878.713-1.592 1.59-1.592h20.152zm.53 19.622V1.974a.531.531 0 00-.53-.531h-5.834v19.09h5.834c.291 0 .53-.238.53-.53zm-7.424.53H8.818V1.444h6.364v19.09zm-13.258 0h5.833V1.444H1.924a.531.531 0 00-.53.53v18.03c0 .292.238.53.53.53z"
  })));
}
SvgPrFreeSpins.displayName = 'PrFreeSpins';
export default SvgPrFreeSpins;